import axios from "axios";
const getAuthToken = () => {
  const auth = localStorage.getItem("auth")
    ? localStorage.getItem("auth")
    : null;
  if (auth) {
    return `Bearer ${auth}`;
  }
  return null;
};

const logout = axios.create({
  baseURL: process.env.REACT_APP_LOGINURL,
  headers: {
    "Content-Type": "application/json",
  },
});
logout.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      Authorization: getAuthToken(),
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const request = {
  get: (url, params) =>
    logout
      .get(url, { params })
      .then((res) => res.data)
      .catch((res) => {
        if (res?.response?.status === 401) {
          localStorage.clear();
          window.location = "/login";
        }
      }),
};
//*1. Get Peer Message
export const getLogout = () => request.get("/logouts");
